export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/advantage-operation.f45d24f3-085f5b.svg";